var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFingerprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1675 6.33504C21.1326 7.64985 21.5449 9.18841 21.3412 10.7143V11.5901C21.34 12.5123 21.6344 13.4185 22.1948 14.2177",
    stroke: "#4A5056",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53613 9.83844C8.53613 8.90928 8.98581 8.01817 9.78623 7.36116C10.5867 6.70414 11.6723 6.33504 12.8042 6.33504C13.9362 6.33504 15.0218 6.70414 15.8223 7.36116C16.6227 8.01817 17.0724 8.90928 17.0724 9.83844V10.7143C17.0724 12.6094 17.8212 14.4533 19.2064 15.9694",
    stroke: "#4A5056",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8042 9.83844V11.5901C12.8008 14.0945 13.7317 16.5398 15.4718 18.5969",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53613 13.3418C8.79724 15.1722 9.4473 16.9509 10.4568 18.5969",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22865 16.8453C4.50867 14.8574 4.18439 12.7871 4.26833 10.7144V9.83852C4.26424 8.60695 4.65568 7.39625 5.40323 6.32842C6.15077 5.26059 7.22799 4.37335 8.52635 3.75612C9.82471 3.13888 11.2983 2.81344 12.7987 2.81261C14.2991 2.81177 15.7733 3.13556 17.0727 3.75136",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprint);
export default __webpack_public_path__ + "static/media/fingerprint.0c4732fd35a283b5a9f1384f8eb61665.svg";
export { ForwardRef as ReactComponent };